import { Link, useSearchParams } from "react-router-dom"
import { IconTooMe } from "../../Icons"
import styles from './NavLogo.module.css';
import CONFIG from './Config.module.css';
import { NavBarSiteSearchParamsValues } from "./Index";

export const NavLogo = ({ className }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    searchParams.delete(NavBarSiteSearchParamsValues.nav_value);
    const urlParams = new URLSearchParams(searchParams).toString();
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }
    return <Link to={`../?${urlParams}`} onClick={scrollToTop} aria-label="Acesse a página principal">
        <IconTooMe className={`${CONFIG.CONFIG} ${styles.NavLogo} ${className}`} color='#fff' />
    </Link>
}